<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>My Pre-owned Orders</li>
    </ul>
  </div>
  <div class="my_orders_listing">
    <!-- TABLE-LISTING -->
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex="100" fxFlexFill>
        <!-- tables-section -->
        <section class="table_section">
          <!-- TABS -->
          <form [formGroup]="filterForm">
            <div class="custom-tabs">
              <mat-button-toggle-group formControlName="status" class="horizontal-toggle-buttons tabs-button-group"
                (change)="setStatus()">
                <mat-button-toggle value="PENDING">
                  <span class="mat-button-content"> Pending </span>
                  <span class="total-count">{{statusWiseCount?.pending?.aggregate?.count}}</span>
                </mat-button-toggle>
                <mat-button-toggle value="APPROVED">
                  <span class="mat-button-content"> Approved </span>
                  <span class="total-count">{{statusWiseCount?.approved?.aggregate?.count}}</span>
                </mat-button-toggle>
                <mat-button-toggle value="SHIPPED">
                  <span class="mat-button-content"> Shipped </span>
                  <span class="total-count"> {{statusWiseCount?.shipped?.aggregate?.count}} </span>
                </mat-button-toggle>
                <mat-button-toggle value="DELIVERED">
                  <span class="mat-button-content"> Delivered </span>
                  <span class="total-count"> {{statusWiseCount?.delivered?.aggregate?.count}} </span>
                </mat-button-toggle>
                <mat-button-toggle value="CANCELLED">
                  <span class="mat-button-content"> Cancelled </span>
                  <span class="total-count"> {{statusWiseCount?.cancelled?.aggregate?.count}} </span>
                </mat-button-toggle>
                <mat-button-toggle value="REFUNDED">
                  <span class="mat-button-content"> Refunded </span>
                  <span class="total-count"> {{statusWiseCount?.refunded?.aggregate?.count}} </span>
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <!-- Table Header -->
            <div class="table_header">
              <div class="table_header_left">
                <!-- SEARCH -->
                <div class="table_search_box">
                  <div class="custom-form-group">
                    <div class="custom-form-control">
                      <mat-form-field appearance="outline">
                        <input type="search" matInput formControlName="search" placeholder="Search by order number"
                          (keyup)="searchOrdersByOrderNumber()">
                        <mat-icon matSuffix>
                          <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="img"
                            class="search-icon">
                        </mat-icon>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table_header_right">
                <button type="button" mat-button class="btn btn-sm bulk_filter_btn clear_filter_btn"
                  (click)="clearFilters()" *ngIf="filters.length">
                  Clear Filters
                </button>
                <button type="button" mat-button class="btn btn-sm bulk_filter_btn" (click)="filterToggle()">
                  <img src="../../../../../../../assets/images/icons/filter_slide.svg" alt="">
                  <span class="btn-content">Filter By :</span>
                  <img src="../../../../../../../assets/images/icons/filter_dropdown.svg" alt="">
                </button>
              </div>
            </div>
            <section [@openCloseFilter]="openFilter ? true : false" class="openclose-filter-sec">
              <!-- FILTER-SECTION-ADD -->
              <section class="table-filter-sec" formArrayName="filters">
                <!-- first-filter-row -->
                <div class="table-filter-row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                  fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutGap="15px"
                  *ngFor="let single of filters.controls;let i = index" [formGroupName]="i">
                  <div class="filter-column" fxLayout="column" fxFlex="30" fxFlexFill>
                    <div class="custom-form-group">
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <mat-select placeholder="Select column" formControlName="column">
                            <mat-option disabled value=""> Select Column </mat-option>
                            <mat-option *ngFor="let single of columnList" [value]="single">{{single.title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="filter-column" fxLayout="column" fxFlex="30" fxFlexFill>
                    <div class="custom-form-group">
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <mat-select placeholder="Select column" formControlName="operator">
                            <mat-option disabled value=""> Select Operator </mat-option>
                            <mat-option *ngFor="let single of single.get('column')?.value?.operators"
                              [value]="single.operator">{{single.title}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="filter-column" fxLayout="column" fxFlex="30" fxFlexFill>
                    <div class="custom-form-group">
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline">
                          <input matInput placeholder="Enter" formControlName="value" (keyup)="filterChange()">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="filter_btn_column" fxLayout="column" fxFlex="10" fxFlexFill fxLayoutAlign="end end">
                    <!-- FILTER-ADD-BTN -->
                    <button type="button" mat-button class="btn btn-sm add_filter_btn global-btn" (click)="plusField()"
                      *ngIf="i === 0">
                      Add Filter
                    </button>
                    <!-- FILTER-Remove-BTN -->
                    <button type="button" mat-button class="remove_form_array_btn" (click)="minusField(i)"
                      *ngIf="i !== 0">
                      <i class="material-icons">close</i>
                    </button>
                  </div>
                </div>
              </section>
            </section>
          </form>
          <!-- table-data -->
          <!-- TABLE-LISTING -->
          <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
            <perfect-scrollbar>
              <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
                (matSortChange)="changeSort($event)">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <!-- Position Column -->
                <ng-container matColumnDef="sNo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>S.No</th>
                  <td mat-cell *matCellDef="let element; let i = dataIndex" data-label="S.No"> {{offset.value + i + 1}}
                  </td>
                </ng-container>
                <!-- Order Id Column -->
                <ng-container matColumnDef="order_number">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Order No</th>
                  <td mat-cell *matCellDef="let element" data-label="Order No"> {{element.order_number}} </td>
                </ng-container>
                <!-- Customer Name Column -->
                <ng-container matColumnDef="customerName">
                  <th mat-header-cell *matHeaderCellDef>Customer Name</th>
                  <td mat-cell *matCellDef="let element" data-label="Customer Name">
                    {{element.dental_supplier?.name}}
                    {{element.dental_practice?.name}}
                    {{element.dental_professional?.name}}
                  </td>
                </ng-container>
                <!-- Supplier Name Column -->
                <ng-container matColumnDef="supplierName">
                  <th mat-header-cell *matHeaderCellDef> Supplier Name</th>
                  <td mat-cell *matCellDef="let element" data-label="Supplier Name">
                    {{element.second_hand_supply?.dental_supplier?.business_name}}
                    {{element.second_hand_supply?.dental_practice?.name}}
                    {{element.second_hand_supply?.dental_professional?.name}}
                  </td>
                </ng-container>
                <!-- Amount Column -->
                <ng-container matColumnDef="total_amount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Amount</th>
                  <td mat-cell *matCellDef="let element" data-label="Total Amount"> AUD {{element.total_amount}} </td>
                </ng-container>
                <!-- Contact Email Column -->
                <ng-container matColumnDef="contactEmail">
                  <th mat-header-cell *matHeaderCellDef>Contact Email</th>
                  <td mat-cell *matCellDef="let element" data-label="Contact Email">
                    {{element.dental_supplier?.email}}
                    {{element.dental_practice?.email}}
                    {{element.dental_professional?.email}}
                  </td>
                </ng-container>
                <!-- Contact Number Column -->
                <ng-container matColumnDef="contactNumber">
                  <th mat-header-cell *matHeaderCellDef>Contact Number</th>
                  <td mat-cell *matCellDef="let element" data-label="Contact Number">
                    {{element.dental_supplier?.phone}}
                    {{element.dental_practice?.phone}}
                    {{element.dental_professional?.phone}}
                  </td>
                </ng-container>
                <!-- Payment Mode Column -->
                <ng-container matColumnDef="payment_mode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Mode</th>
                  <td mat-cell *matCellDef="let element" data-label="Payment Mode">
                    <span class="table-chip view-chip" [ngClass]="{
                      'pending-chip': element?.payment_mode === 'ACCOUNT_PAY',
                      'active-chip': element?.payment_mode === 'ONLINE'
                      }">
                      {{element?.payment_mode | titlecase }}
                    </span>
                  </td>
                </ng-container>
                <!-- Payment Status Column -->
                <ng-container matColumnDef="payment_status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Status</th>
                  <td mat-cell *matCellDef="let element" data-label="Payment Status">
                    <span class="table-chip view-chip" [ngClass]="{
                      'pending-chip': element?.payment_status === 'PENDING',
                      'active-chip': element?.payment_status === 'PAID'
                      }">
                      {{element?.payment_status | titlecase}}
                    </span>
                  </td>
                </ng-container>
                <!-- Action Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    <span class="tab_head"> Action </span>
                  </th>
                  <td mat-cell *matCellDef="let element" data-label="action" (click)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()" style="pointer-events:all;" data-label="Action">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" class="table-action-btn">
                      <button type="button" class="view" mat-menu-item
                        [routerLink]='["/dashboard/pre-owned-orders/view", element.id]'>
                        <img src="../../../../../../../assets/images/icons/action_icons/view.svg" alt="img">
                        <span> View Details </span>
                      </button>
                      <button type="button" class="view" mat-menu-item (click)="changeStatusDialog(element)"
                        *ngIf="element.status !== 'CANCELLED' && element.status !== 'DELIVERED' && element.status !== 'REFUNDED' && ['SUPPLIER', 'PROFESSIONAL', 'PRACTICE'].includes(loginData.type)">
                        <img src="../../../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Change Status </span>
                      </button>
                      <button type="button" class="view" mat-menu-item (click)="refundOrderDialog(element)"
                        *ngIf="['PENDING', 'CANCELLED'].includes(status.value) && ['SUPPLIER', 'PROFESSIONAL', 'PRACTICE'].includes(loginData.type)">
                        <img src="../../../../../../../assets/images/icons/action_icons/edit.svg" alt="img">
                        <span> Refund Order </span>
                      </button>
                    <!-- <button type="button" class="view" mat-menu-item (click)="viewInvoice(element)"
                        *ngIf="'DELIVERED' === status.value" >
                        <img src="../../../../../../../assets/images/icons/action_icons/view.svg" alt="img">
                        <span> View Invoice </span>
                      </button>-->
                      <button type="button" class="view" mat-menu-item (click)="viewInvoice(element)">
                        <img src="../../../../../../../assets/images/icons/action_icons/view.svg" alt="img">
                        <span> View Invoice </span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>
                <ng-container matColumnDef="loading">
                  <th mat-footer-cell *matFooterCellDef colspan="8">
                    <div class="custom-loader ">
                      <div class="custom-loader custom_logo_loader">
                        <img src='../../../../../images2/loader.gif' alt="img" loading="lazy" />
                      </div>
                    </div>
                  </th>
                </ng-container>
                <ng-container matColumnDef="noData">
                  <th mat-footer-cell *matFooterCellDef colspan="8" class="no-data empty-img">
                    <img src='../../../../../../../assets/images/empty-imgs/no_products.svg' alt="img" loading="lazy" />
                    <h4 class="no_state_heading">No Pre-Owned orders</h4>
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource != null }"></tr>
                <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource != null && dataSource.filteredData.length == 0)
            }"></tr>
              </table>
            </perfect-scrollbar>
          </div>
          <!-- TABLE-PAGINATOR -->
          <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
            fxFlexFill fxLayoutGap="8px">
            <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)">
            </mat-paginator>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
